import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row display-property" }
const _hoisted_2 = { class: "col iodine-label display-property-label" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}

interface Props {
  label: string
  value: string,
  loading?: boolean,
  loaderWidth?: string,
  horizontal?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayProperty',
  props: {
    label: {},
    value: {},
    loading: { type: Boolean },
    loaderWidth: {},
    horizontal: { type: Boolean, default: false }
  },
  setup(__props: any) {


const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
      (_ctx.horizontal)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "col display-property-value"
          }, _toDisplayString(_ctx.value), 513)), [
            [_vShow, !_ctx.loading]
          ])
        : _createCommentVNode("", true),
      (_ctx.horizontal)
        ? _withDirectives((_openBlock(), _createBlock(_component_q_skeleton, {
            key: 1,
            width: _ctx.loaderWidth || '50%'
          }, null, 8, ["width"])), [
            [_vShow, _ctx.loading]
          ])
        : _createCommentVNode("", true)
    ]),
    (!_ctx.horizontal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("div", { class: "col display-property-value" }, _toDisplayString(_ctx.value), 513), [
            [_vShow, !_ctx.loading]
          ]),
          (!_ctx.horizontal)
            ? _withDirectives((_openBlock(), _createBlock(_component_q_skeleton, {
                key: 0,
                width: _ctx.loaderWidth || '95%'
              }, null, 8, ["width"])), [
                [_vShow, _ctx.loading]
              ])
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})